export const IN_NETWORK = { value: 'IN_NETWORK' };
export const OUT_NETWORK = { value: 'OUT_NETWORK' };
export const FREQUENCIES: { [key: string]: { value: string; label: string } } =
  {
    MONTHLY: { value: 'MONTHLY', label: 'Monthly' },
    SEMI_MONTHLY: { value: 'SEMI_MONTHLY', label: 'Semi-Monthly' },
    WEEKLY: { value: 'WEEKLY', label: 'Weekly' },
    BI_WEEKLY: { value: 'BI_WEEKLY', label: 'Bi-Weekly' },
  };

export const BENEFIT_CATEGORY = {
  MEDICAL: {
    value: 'MEDICAL',
  },
};

export const N_TIER = 'N_TIER';
export const AGE_BAND = 'AGE_BAND';
export const AGE_BAND_LABEL = 'Age Banded';
export const FOUR_TIER = 'FOUR_TIER';

export const FOUR_TIER_COVERAGES = [
  {
    title: '4-Tier',
    name: '4-Tier',
    type: 'FOUR_TIER',
    items: [
      {
        value: 'Y0C',
        fourTierValue: 'EE',
        nTierValue: 'EE',
        label: 'Just You',
        coverageLabel: 'Covers you',
      },
      {
        value: 'Y1S0C',
        fourTierValue: 'ES',
        nTierValue: 'ES',
        label: 'You + Spouse',
        coverageLabel: 'Covers you + Spouse',
      },
      {
        value: 'Y1C',
        fourTierValue: 'EC',
        nTierValue: 'EC',
        label: 'You + Child(ren)',
        coverageLabel: 'Covers you + Child(ren)',
      },

      {
        value: 'Y1S1C',
        fourTierValue: 'EF',
        nTierValue: 'EF',
        label: 'You + Family',
        coverageLabel: 'Covers you + Family',
      },
    ],
  },
];

export const N_TIER_COVERAGES = [
  {
    title: 'Coverage Options',
    name: 'Coverage Options',
    items: [
      {
        value: 'Y0C',
        fourTierValue: 'EE',
        nTierValue: 'EE',
        label: 'Just You',
        coverageLabel: 'Covers you',
      },
      {
        value: 'Y1C',
        fourTierValue: 'ES',
        nTierValue: 'EE_PLUS_1',
        label: 'You + 1',
        coverageLabel: 'Covers you + child',
        // Add support for dual tier values for Y1C
        alternativeFourTierValue: 'EC',
        showBothTierValues: true,
      },
      {
        value: 'Y2C',
        fourTierValue: 'EF',
        nTierValue: 'EE_PLUS_2',
        label: 'You + 2',
        coverageLabel: 'Covers you + children',
      },
      {
        value: 'Y3C',
        fourTierValue: 'EF',
        nTierValue: 'EE_PLUS_3',
        label: 'You + 3',
        coverageLabel: 'Covers you + children',
      },
      {
        value: 'Y4C',
        fourTierValue: 'EF',
        nTierValue: 'EE_PLUS_4',
        label: 'You + 4',
        coverageLabel: 'Covers you + children',
      },
      {
        value: 'Y5C',
        fourTierValue: 'EF',
        nTierValue: 'EE_PLUS_5',
        label: 'You + 5',
        coverageLabel: 'Covers you + children',
      },
      {
        value: 'Y6C',
        fourTierValue: 'EF',
        nTierValue: 'EE_PLUS_6',
        label: 'You + 6',
        coverageLabel: 'Covers you + children',
      },
    ],
  },
];

export const NO_INFO = 'No Info';
export const NOT_COVERED_FORMATTED = 'Not Covered';
export const NOT_APPLICABLE_FORMATTED = 'Not Applicable';

export const SUPER_SCRIPTS = [
  {
    strValue: 'SUP-1',
    superScriptValue: 1,
    label: '1 After Deductible is Met ',
  },
  {
    strValue: 'SUP-2',
    superScriptValue: 2,
    label: '2 Before Deductible is Met ',
  },
];

export const COST_TYPE = {
  COINSURANCE: 'coinsurance',
  COPAY: 'copay',
  OTHER: 'other',
};

export const NETWORK_PREFIX = {
  IN: 'in',
  OUT_OF: 'outOf',
};

export const SERVICE_APPLICABLE = {
  COVERED: 'COVERED',
  NOT_COVERED: 'NOT_COVERED',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
};

export const LIFE_PLAN_TYPES = {
  BASIC_LIFE: { value: 'BASIC_LIFE', label: 'Basic Life' },
  BASIC_ADD: { value: 'BASIC_ADD', label: 'Basic AD&D' },
  BASIC_LIFE_AND_ADD: {
    value: 'BASIC_LIFE_AND_ADD',
    label: 'Basic Life w/AD&D',
  },
  STD: { value: 'STD', label: 'Basic Short-Term Disability' },
  LTD: { value: 'LTD', label: 'Basic Long-Term Disability' },
};

export const VOLUNTARY_LIFE_PLAN_TYPES = {
  VOLUNTARY_LIFE: { value: 'VOLUNTARY_LIFE', label: 'Voluntary Life' },
  VOLUNTARY_ADD: { value: 'VOLUNTARY_ADD', label: 'Voluntary AD&D' },
  VOLUNTARY_LIFE_ADD: {
    value: 'VOLUNTARY_LIFE_ADD',
    label: 'Voluntary Life w/AD&D',
  },
  VOLUNTARY_STD: {
    value: 'VOLUNTARY_STD',
    label: 'Voluntary Short-Term Disability',
  },
  VOLUNTARY_LTD: {
    value: 'VOLUNTARY_LTD',
    label: 'Voluntary Long-Term Disability',
  },
};

// Both life-picker reads write the same list, so they must ask for the same
// kinds; otherwise whichever response lands last decides what the picker shows.
// The list must cover every kind the page saves: a held plan missing from it
// reads as stale and Save drops it.
export const LIFE_PICKER_KINDS = [
  ...Object.keys(LIFE_PLAN_TYPES),
  ...Object.keys(VOLUNTARY_LIFE_PLAN_TYPES),
];

export const LIFE_AND_DISABILITY_CARD_ORDER = [
  LIFE_PLAN_TYPES.BASIC_LIFE.value,
  LIFE_PLAN_TYPES.BASIC_ADD.value,
  LIFE_PLAN_TYPES.BASIC_LIFE_AND_ADD.value,
  LIFE_PLAN_TYPES.STD.value,
  VOLUNTARY_LIFE_PLAN_TYPES.VOLUNTARY_STD.value,
  LIFE_PLAN_TYPES.LTD.value,
  VOLUNTARY_LIFE_PLAN_TYPES.VOLUNTARY_LTD.value,
  VOLUNTARY_LIFE_PLAN_TYPES.VOLUNTARY_LIFE.value,
  VOLUNTARY_LIFE_PLAN_TYPES.VOLUNTARY_ADD.value,
  VOLUNTARY_LIFE_PLAN_TYPES.VOLUNTARY_LIFE_ADD.value,
];

export const LIFE_BENEFIT_OPTIONS = {
  FLAT_AMOUNT: 'FLAT_AMOUNT',
  MULTIPLIER_OF_SALARY: 'MULTIPLIER_OF_SALARY',
  MULTIPLIER_OF_SALARY_AND_FLAT_AMOUNT: 'MULTIPLIER_OF_SALARY_AND_FLAT_AMOUNT',
};

export const PLAN_TYPE_PPO = 'PPO';
export const PLAN_TYPE_HMO = 'HMO';
export const PLAN_TYPE_EPO = 'EPO';
export const PLAN_TYPE_POS = 'POS';
export const PLAN_TYPE_OAP = 'OAP';
export const PLAN_TYPE_HSA = 'HSA';

export const addPlansTooltipContent = `You may only add plans that have the same plan year and benefit classes as this guide. If there are plans that you expected to be available for this guide, please confirm that the plans and guide share at least one benefit class and that their plan years match.`;
export const addPlansDatedTooltipContent = `You may only add plans that have the same effective date and benefit classes as this guide. If there are plans that you expected to be available for this guide, please confirm that the plans and guide share at least one benefit class and that their effective dates match.`;

export const NDASH = '–';

export const RX_TIER_LABELS = [
  { value: 'TIER_1', label: 'Retail Tier 1' },
  { value: 'TIER_2', label: 'Retail Tier 2' },
  { value: 'TIER_3', label: 'Retail Tier 3' },
  { value: 'TIER_4', label: 'Retail Tier 4' },
  { value: 'TIER_5', label: 'Retail Tier 5' },
  { value: 'TIER_6', label: 'Retail Tier 6' },
  { value: 'TIER_7', label: 'Retail Tier 7' },
  { value: 'TIER_8', label: 'Retail Tier 8' },
];

export const MAIL_ORDER_RX_TIER_LABELS = [
  { value: 'TIER_1', label: 'Mail Order Tier 1' },
  { value: 'TIER_2', label: 'Mail Order Tier 2' },
  { value: 'TIER_3', label: 'Mail Order Tier 3' },
  { value: 'TIER_4', label: 'Mail Order Tier 4' },
  { value: 'TIER_5', label: 'Mail Order Tier 5' },
  { value: 'TIER_6', label: 'Mail Order Tier 6' },
  { value: 'TIER_7', label: 'Mail Order Tier 7' },
  { value: 'TIER_8', label: 'Mail Order Tier 8' },
];
export const MOBILE_DEDUCTIBLE_LABELS = [
  {
    value: 'deductibles',
    label: 'Individual Deductible',
    fieldSpecialization: 'individual',
    type: 'DENTAL',
  },
  {
    value: 'deductibles',
    label: 'Family Deductible',
    fieldSpecialization: 'family',
    type: 'DENTAL',
  },
  {
    value: 'outOfPocket',
    label: 'Individual Out-of-Pocket Max',
    fieldSpecialization: 'individual',
  },
  {
    value: 'outOfPocket',
    label: 'Family Out-of-Pocket Max',
    fieldSpecialization: 'family',
  },

  {
    value: 'calendarYearMax',
    label: 'Annual Maximum (Per Person)',
    type: 'DENTAL',
  },
  {
    value: 'orthodontiaLifetimeMax',
    label: 'Orthodontia Maximum',
    type: 'DENTAL',
  },
];

export const MOBILE_DENTAL_DEDUCTIBLE_LABELS = [
  {
    value: 'calendarYearMax',
    label: 'Annual Maximum (Per Person)',
    type: 'DENTAL',
  },
  {
    value: 'deductibles',
    label: 'Individual Deductible',
    fieldSpecialization: 'individual',
    type: 'DENTAL',
  },
  {
    value: 'deductibles',
    label: 'Family Deductible',
    fieldSpecialization: 'family',
    type: 'DENTAL',
  },
  {
    value: 'orthodontiaLifetimeMax',
    label: 'Orthodontia Maximum',
    type: 'DENTAL',
  },
];

export const VISION_FREQUENCIES = [
  {
    fieldName: 'eyeExam',
    fieldValue: 'Eye Exam Frequency',
    fieldDescription: 'Eye exam',
    fieldFormatter: 'customServiceFormatter',
    serviceBenefitCode: 102,
  },
  {
    fieldName: 'lenses',
    fieldValue: 'Lenses Frequency',
    fieldDescription: 'Lenses',
    fieldFormatter: 'customServiceFormatter',
    serviceBenefitCode: 103,
  },
  {
    fieldName: 'frames',
    fieldValue: 'Frames Frequency',
    fieldDescription: 'Frames',
    fieldContext: 'frequency',
    fieldFormatter: 'customServiceFormatter',
    serviceBenefitCode: 104,
  },
];

export const MOBILE_IND_DEDUCTIBLE_LABELS = [
  {
    value: 'indWithinFamilyOOPMax',
    label: 'Out-of-Pocket Max (Ind within Fam)',
  },
  { value: 'indWithinFamilyDeductible', label: 'Deductible (Ind within Fam)' },
];

export const MOBILE_RX_DEDUCTIBLE_OOP_LABELS = [
  {
    type: 'item',
    value: 'rxDeductibles',
    label: 'Individual Deductible',
    fieldSpecialization: 'individual',
  },
  {
    type: 'item',
    value: 'rxDeductibles',
    label: 'Family Deductible',
    fieldSpecialization: 'family',
  },
  {
    type: 'item',
    value: 'rxOOP',
    label: 'Individual Out-of-Pocket Max',
    fieldSpecialization: 'individual',
  },
  {
    type: 'item',
    value: 'rxOOP',
    label: 'Family Out-of-Pocket Max',
    fieldSpecialization: 'family',
  },
];

export const PLAN_DESCRIPTION_WORD_LIMIT = 2500;

export const MEDICAL_SERVICES_LIST = [
  {
    fieldName: 'officeVisit',
    shortName: 'Office Visit',
    serviceBenefitCode: 1,
  },
  {
    fieldName: 'specialistVisit',
    shortName: 'Specialist Visit',
    serviceBenefitCode: 2,
  },
  {
    fieldName: 'virtualCareVisit',
    shortName: 'Virtual Care',
    serviceBenefitCode: 108,
  },
  {
    fieldName: 'preventiveCare',
    shortName: 'Preventive Care',
    serviceBenefitCode: 95,
  },
  {
    fieldName: 'emergencyRoom',
    shortName: 'Emergency Room',
    serviceBenefitCode: 15,
  },
  {
    fieldName: 'urgentCare',
    shortName: 'Urgent Care',
    serviceBenefitCode: 13,
  },
  {
    fieldName: 'coInsurance',
    shortName: 'Coinsurance',
    serviceBenefitCode: 107,
  },
  {
    fieldName: 'labXray',
    shortName: 'Diagnostic Lab/ X-Ray',
    serviceBenefitCode: 77,
  },
  {
    fieldName: 'complexImaging',
    shortName: 'Complex Imaging',
    serviceBenefitCode: 37,
  },
  {
    fieldName: 'inpatient',
    shortName: 'Hospital Inpatient',
    serviceBenefitCode: 87,
  },
  {
    fieldName: 'outPatient',
    shortName: 'Hospital Outpatient',
    serviceBenefitCode: 88,
  },
  {
    fieldName: 'chiropracticCare',
    shortName: 'Chiropractic Care',
    serviceBenefitCode: 34,
  },
  {
    fieldName: 'acupuncture',
    shortName: 'Acupuncture Care',
    serviceBenefitCode: 40,
  },
];

export const DENTAL_SERVICES_LIST = [
  {
    fieldName: 'preventive',
    shortName: 'Preventive Care',
    serviceBenefitCode: 38,
  },
  {
    fieldName: 'basicDentalCare',
    shortName: 'Basic Care',
    serviceBenefitCode: 53,
  },
  {
    fieldName: 'basicDentalCareChild',
    shortName: 'Basic Dental Care (Child)',
    serviceBenefitCode: 50,
  },

  {
    fieldName: 'majorDentalCare',
    shortName: 'Major Care',
    serviceBenefitCode: 55,
  },
  {
    fieldName: 'endodonticCare',
    shortName: 'Endodontic Care',
    serviceBenefitCode: 99,
  },
  {
    fieldName: 'periodonticCare',
    shortName: 'Periodontic Care',
    serviceBenefitCode: 100,
  },
  {
    fieldName: 'waitingPeriod',
    shortName: 'Waiting Period',
    serviceBenefitCode: 98,
  },
  {
    fieldName: 'implants',
    shortName: 'Implants',
    serviceBenefitCode: 101,
  },
  {
    fieldName: 'outOfNetworkReimbursement',
    shortName: 'Out-of-Network Reimbursement',
    serviceBenefitCode: 97,
    availableOnly: 'OUT',
  },
];

export const VISION_SERVICES_LIST = [
  {
    fieldName: 'exam',
    shortName: 'Exam Copay',
    serviceBenefitCode: 12,
  },
  {
    fieldName: 'materialsCopay',
    shortName: 'Materials Copay',
    serviceBenefitCode: 109,
  },
  {
    fieldName: 'eyeGlassLensesSingle',
    shortName: 'Eyeglass Lenses Single',
    serviceBenefitCode: 72,
  },
  {
    fieldName: 'eyeGlassLensesBifocal',
    shortName: 'Eyeglass Lenses Bifocal',
    serviceBenefitCode: 73,
  },
  {
    fieldName: 'eyeGlassLensesTrifocal',
    shortName: 'Eyeglass Lenses Trifocal',
    serviceBenefitCode: 74,
  },

  {
    fieldName: 'eyeGlassLensesLenticular',
    shortName: 'Eyeglass Lenses Lenticular',
    serviceBenefitCode: 110,
  },
  {
    fieldName: 'frames',
    shortName: 'Frames',
    serviceBenefitCode: 71,
  },
  {
    fieldName: 'electiveContacts',
    shortName: 'Elective Contacts',
    serviceBenefitCode: 75,
  },
  {
    fieldName: 'medicallyNeccessaryContacts',
    shortName: 'Medically Necessary Contacts',
    serviceBenefitCode: 76,
  },
];

export const VISION_FREQUENCY_LIST = [
  {
    fieldName: 'eyeExam',
    shortName: 'Eye Exam Frequency',
    serviceBenefitCode: 102,
  },
  {
    fieldName: 'lenses',
    shortName: 'Lenses Frequency',
    serviceBenefitCode: 103,
  },
  {
    fieldName: 'frames',
    shortName: 'Frames Frequency',
    serviceBenefitCode: 104,
  },
];
